/* eslint-disable no-case-declarations */
import getOrdinal from '../../../../helpers/getOrdinal';

function computePreviousDate(day, offset) {
  const newDay = day - offset;
  if (newDay > 0) {
    return getOrdinal(newDay);
  }
  let adjustedDay = newDay % 31;
  if (adjustedDay <= 0) {
    adjustedDay += 31;
  }
  return getOrdinal(adjustedDay);
}

export const calculateY = ({
  setting,
  beforeAfter,
  loanPaymentDueDay,
  dayOffset,
}) => {
  switch (true) {
    case setting === 'offset' && beforeAfter === 'before':
      return computePreviousDate(+loanPaymentDueDay, +dayOffset);
    case setting === 'offset' && beforeAfter === 'after':
      return getOrdinal(+loanPaymentDueDay + +dayOffset);
    case setting === 'specific':
      return getOrdinal(dayOffset);
    default:
      return '';
  }
};
